// 대시보드 목록의 위험도 판정. Dashboard.js 에서 옮겼다(2026-09-14).
// ⚠️ 화면마다 임계값이 다르다(docs/design-phase2-features.md #14). 이 파일은 "대시보드 기준"이다.
//    주치의 신청/조회가 대시보드와 같은 신호등을 그리려고 이것을 쓴다. 다른 화면의
//    getRiskLevel 을 이것으로 바꾸지 말 것 — 그 화면의 색이 조용히 바뀐다.
// color 값은 옛 코드 그대로다. 화면은 이 색을 쓰지 않고 level 문자열로 RiskDot 이 토큰 색을 고른다.
const getDashboardRiskLevel = (value, type) => {
    if (value === null || value === undefined || value === 0 || value === '') {
        return { level: "기록 없음", color: "#AAAAAA" };
    }

    switch (type) {
        case 'BLOOD_GLUCOSE':
            if (value < 70) return { level: "위험 (저혈당)", color: "#000080" };
            if (value <= 100) return { level: "정상", color: "#2ECC40" };
            if (value <= 125) return { level: "경고 (고혈당 주의)", color: "#FFDC00" };
            if (value > 125) return { level: "위험 (고혈당)", color: "#FF4136" };
            return { level: "기록 없음", color: "#AAAAAA" };
        case 'BLOOD_GLUCOSE_MEAL':
            if (value < 90) return { level: "위험 (저혈당)", color: "#000080" };
            if (value <= 140) return { level: "정상", color: "#2ECC40" };
            if (value <= 200) return { level: "경고 (고혈당 주의)", color: "#FFDC00" };
            if (value > 200) return { level: "위험 (고혈당)", color: "#FF4136" };
            return { level: "기록 없음", color: "#AAAAAA" };
        case 'BP_SYSTOLIC':
            if (value < 90) return { level: "위험 (저혈압)", color: "#000080" };
            if (value <= 120) return { level: "정상", color: "#2ECC40" };
            if (value <= 140) return { level: "경고 (고혈압 주의)", color: "#FFDC00" };
            if (value > 140) return { level: "위험 (고혈압)", color: "#FF4136" };
            return { level: "기록 없음", color: "#AAAAAA" };
        case 'BP_DIASTOLIC':
            if (value < 60) return { level: "위험 (저혈압)", color: "#000080" };
            if (value <= 80) return { level: "정상", color: "#2ECC40" };
            if (value <= 90) return { level: "경고 (고혈압 주의)", color: "#FFDC00" };
            if (value > 90) return { level: "위험 (고혈압)", color: "#FF4136" };
            return { level: "기록 없음", color: "#AAAAAA" };
        case 'BMI':
            if (value < 18.5) return { level: "위험 (저체중)", color: "#000080" };
            if (value <= 23.0) return { level: "정상", color: "#2ECC40" };
            if (value <= 25.0) return { level: "경고 (과체중 주의)", color: "#FFDC00" };
            if (value > 25.0) return { level: "위험 (비만)", color: "#FF4136" };
            return { level: "기록 없음", color: "#AAAAAA" };
        default:
            return { level: "기록 없음", color: "#AAAAAA" };
    }
};

export default getDashboardRiskLevel;
